import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { ACCESSIBLE_ACCOUNTS_QUERY_KEY } from '@/consts/accounts';
import { useImpersonation } from '@/contexts/ImpersonationContext';
import { getAccessibleAccounts } from '@/services/accounts';
import { CACHE_TTL } from '@/services/constants';
import { BACKGROUND_QUERY_META } from '@/utils/backgroundQuery';

export default function useAccessibleAccounts() {
  const { impersonatedUserId } = useImpersonation();

  const { data, isLoading, isError } = useQuery({
    queryKey: ACCESSIBLE_ACCOUNTS_QUERY_KEY,
    queryFn: getAccessibleAccounts,
    staleTime: CACHE_TTL,
    retry: false,
    meta: BACKGROUND_QUERY_META,
  });

  return useMemo(() => {
    const accounts = data ?? [];

    // Quem impersona sem estar na lista é o suporte: para ele o seletor novo não
    // vale, e o painel segue como hoje.
    const currentAccount = impersonatedUserId
      ? accounts.find((account) => account.ownerId === String(impersonatedUserId))
      : accounts.find((account) => account.isOwn);

    return {
      accounts,
      currentAccount: currentAccount ?? null,
      isLoading,
      isAvailable: !isLoading && !isError && Boolean(currentAccount),
    };
  }, [data, impersonatedUserId, isError, isLoading]);
}
